import { i, s as t, u as r } from "./release-BueoVUqq.js";
export {
  i as initWidget,
  t as subscribeToWidgetEvents,
  r as unsubscribeFromWidgetEvents
};
